<div id="list" >
    <div class="table-container col-sm-12">
        <table mat-table  matSort [dataSource]="matDataSourceFourn" (matSortChange)="trieTab($event)" matSortActive="dCreation"
            matSortDirection="desc" matSortDisableClear>
            <caption>Liste des fournisseurs</caption>
            <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Code </th>
                <td mat-cell *matCellDef="let element" class="centrer"> {{element.code}} </td>
            </ng-container>
            <ng-container matColumnDef="libelle">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Libelle </th>
                <td mat-cell *matCellDef="let element"> 
                    <div class="with-padding-left">
                        {{element.libelle}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="siret">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> N° SIRET </th>
                <td mat-cell *matCellDef="let element" class="centrer"> {{element.siret}} </td>
            </ng-container>
            <ng-container matColumnDef="adresse">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Adresse </th>
                <td mat-cell *matCellDef="let element">                      
                    <div class="with-padding-left">
                        {{element.adr1 + " " + element.cp + " " + element.ville}} 
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="tel">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Téléphone</th>
                <td mat-cell *matCellDef="let element" class="centrer"> {{element.tel}} </td>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectFournisseur(row)" ></tr>
        </table>
        <div class="footer">
            <mat-paginator #paginator class="paginator" [length]="this.length" [pageIndex]="pageIndex" [pageSize]="pageSize"
                [pageSizeOptions]="[10, 20, 50]" (page)="changePage($event)">
            </mat-paginator>
        </div>
    </div>
</div>